export default "__VITE_ASSET__SYUECtGp__"